import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function bookingService() {
  function requestBooking(data) {
    return http.post('/v1/bookings/address-change', data, OPTIONS_INTEGRATION)
  }

  function getBookings(params) {
    return http.get('/v1/bookings', { ...OPTIONS_INTEGRATION, ...params })
  }

  function getBookingsRepair(params) {
    return http.get('/v1/bookings', { ...OPTIONS_INTEGRATION, ...params })
  }

  function getBookingsActivation(params) {
    return http.get('/v1/bookings', { ...OPTIONS_INTEGRATION, ...params })
  }

  function sendBookingsRepair(params) {
    return http.post('/v1/bookings/repair', params, OPTIONS_INTEGRATION)
  }

  function changeInstallationDate(params, serviceOrderId) {
    return http.put(`/v1/bookings/${serviceOrderId}`, params, OPTIONS_INTEGRATION)
  }

  return {
    requestBooking,
    getBookings,
    getBookingsRepair,
    getBookingsActivation,
    sendBookingsRepair,
    changeInstallationDate,
  }
}
